// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skip-link+.skip-link[data-v-37c339be]{margin-left:1rem}", ""]);
// Exports
module.exports = exports;
